import { useUserGroupsData } from "../data/use-groups-data";
import { useGroupSlug } from "./use-group-slug";

export function useGroupUuid(): string | null {
  const groupUuid = useGroupSlug(false);
  const { groups } = useUserGroupsData();

  const group = groups.find((group) => group.slug === groupUuid);

  return group?.uuid ?? null;
}
